import { useCallback, useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export type SubscriptionStatus =
  | 'trialing' | 'active' | 'past_due' | 'canceled' | 'suspended'

export interface Plan {
  id: string
  name: string
  price_cents: number
  billing_period: 'monthly' | 'yearly'
  max_users: number
}

export interface Subscription {
  plan_id: string
  status: SubscriptionStatus
  trial_ends_at: string | null
  current_period_end: string | null
}

export function useBilling() {
  const [plans, setPlans] = useState<Plan[]>([])
  const [subscription, setSubscription] = useState<Subscription | null>(null)
  const [loading, setLoading] = useState(true)

  const fetch = useCallback(async () => {
    setLoading(true)
    const [{ data: planRows }, { data: sub }] = await Promise.all([
      supabase.from('plans')
        .select('id, name, price_cents, billing_period, max_users')
        .eq('is_active', true)
        .order('price_cents'),
      supabase.from('subscriptions')
        .select('plan_id, status, trial_ends_at, current_period_end')
        .maybeSingle(),
    ])
    setPlans((planRows ?? []) as Plan[])
    setSubscription((sub as Subscription | null) ?? null)
    setLoading(false)
  }, [])

  useEffect(() => { fetch() }, [fetch])

  const startCheckout = useCallback(async (planId: string): Promise<{ ok: boolean; error?: string }> => {
    const { data } = await supabase.functions.invoke<{ ok: boolean; url?: string; error?: string }>(
      'create-checkout', { body: { plan_id: planId } },
    )
    if (data?.ok && data.url) { window.location.href = data.url; return { ok: true } }
    return { ok: false, error: data?.error ?? 'Falha ao iniciar checkout' }
  }, [])

  return { plans, subscription, loading, startCheckout, refetch: fetch }
}
